<div class="ui-view-header" *ngIf="theme != 'athand'">
    <header>
        <div class="row">
            <div class="col-6 col-offset-0">
                <game-logo [guest]="guest" [logoSize]="logoSize"></game-logo>
            </div>
            <div class="col-6 col-offset-6"></div>
        </div>
    </header>
</div>